<template>
  <div>
    <b-form @submit.prevent="saveSettings" v-if="!fetching">
      <b-row class="manager-fallback-package-setting">
        <b-col sm="12" lg="12" style="padding: 0" class="fallback-package-setting">
          <b-card class="mb-4 default-package-card">
            <b-card-body class="default-package-card-body p-0">
              <div class="container default-package-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <span style="font-weight: semi-bold; font-size: 20pt">{{
                      __('Default Package Settings')
                    }}</span>
                  </div>
                </div>
                <hr class="mt-1" />
                <div class="col-md-12 default-package-form">
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Package') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-7 col-sm-12">
                        <v-select
                          label="name"
                          :options="packages"
                          :value="selectedPackage"
                          @input="handleChangePackage"
                          :placeholder="__('Select package...')"
                        >
                        </v-select>
                      </div>
                    </b-row>
                  </b-form-group>
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Subpackage') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-7 col-sm-12">
                        <v-select
                          label="display_subpackage"
                          :options="subpackages"
                          :value="selectedSubpackage"
                          @input="handleChangeSubpackage"
                          :placeholder="__('Select subpackage...')"
                        >
                        </v-select>
                      </div>
                    </b-row>
                  </b-form-group>

                  <b-row>
                    <b-col sm="12" class="text-center mt-5 mb-3">
                      <b-button variant="primary" @click="saveSettings" class="mb-2">
                        {{ __('Save') }}
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                    {{ message }}
                  </b-alert>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
  data() {
    return {
      fetching: false,
      success: false,
      message: '',
      packages: [],
      subpackages: [],
      selectedPackage: null,
      selectedSubpackage: null,
    };
  },

  async mounted() {
    this.packages = await this.fetchPackages();
    const setting = await this.fetchSetting();

    this.selectedPackage = this.packages.find((pkg) => {
      if (setting === undefined || setting.package === null) {
        return false;
      }
      return pkg.id === setting.package.id;
    });
    this.subpackages = await this.fetchSubpackagesFor(
      this.selectedPackage === undefined ? '1' : this.selectedPackage.id,
    );
    this.selectedSubpackage = this.subpackages.find(
      (subpkg) => subpkg.id === (setting === undefined ? null : setting.id),
    );
  },

  methods: {
    async fetchPackages() {
      const {
        data: { data: packages },
      } = await axios.get('/api/packages');
      return packages;
    },

    async fetchSubpackagesFor(package_id) {
      let {
        data: { data: subpackages },
      } = await axios.get(`/api/packages/${package_id}/subpackages`);
      return subpackages.map((subpackage, index) => ({
        ...subpackage,
        display_subpackage: `${__('Option')} ${index + 1} - ${__(moment.duration(subpackage.period).humanize())} (RM ${
          subpackage.price
        })`,
      }));
    },

    async fetchSetting() {
      this.fetching = true;

      try {
        const {
          data: { data: setting },
        } = await axios.get('/api/fallback_subpackage');

        return setting;
      } catch (err) {
      } finally {
        this.fetching = false;
      }
    },

    async saveSettings() {
      let postData;

      if (!this.selectedPackage && !this.selectedSubpackage) {
        postData = {
          subpackage_id: null,
        };
      } else if (this.selectedPackage && !this.selectedSubpackage) {
        this.success = false;
        this.message = __('Subpackage must be selected');
        return;
      } else {
        postData = {
          subpackage_id: this.selectedSubpackage.id,
        };
      }

      try {
        let response = await axios.post('/api/fallback_subpackage', postData);
        this.success = response.data.success;
        this.message = response.data.message;
      } catch (err) {
        console.log(err);
        this.success = false;
        this.message =
          err.response.data.message && err.response.data.errors.subpackage_id
            ? err.response.data.errors.subpackage_id[0]
            : __('Something went wrong');
      }
    },

    handleChangePackage(selection) {
      if (selection == null) {
        this.selectedPackage = null;
        this.selectedSubpackage = null;
        this.subpackages = [];
        return;
      }

      this.selectedPackage = selection;
      this.fetchSubpackagesFor(selection.id).then((subpackages) => {
        this.selectedSubpackage = null;
        this.subpackages = subpackages;
      });
    },

    handleChangeSubpackage(selection) {
      this.selectedSubpackage = selection;
    },
  },
};
</script>

<style>
.layout-sidebar-large .main-content-wrap {
  background-image: url('@/assets/images/form/form-bg-orange.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

@media only screen and (max-width: 360px) {
  .default-package-card-body,
  .default-package-container {
    padding: 0;
  }

  .default-package-card {
    width: 285px;
  }

  .default-package-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 768px) {
  .default-package-form {
    padding: 0;
  }
}

@media only screen and (max-width: 600px) {
  .manager-fallback-package-setting {
    width: 113% !important;
  }
}
</style>
